import { render, staticRenderFns } from "./GradesPercentages.vue?vue&type=template&id=f7ebf946"
import script from "./GradesPercentages.vue?vue&type=script&lang=js"
export * from "./GradesPercentages.vue?vue&type=script&lang=js"
import style0 from "./GradesPercentages.vue?vue&type=style&index=0&id=f7ebf946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports